/** Routes de la rubrique « Marges et rentabilité » (back-office, permission marge.lire). */
import type { RouteObject } from 'react-router';
import { TrendingUp } from 'lucide-react';
import type { EntreeNav } from '../../../app/navigation';
import { RequirePermission } from '../../../shared/auth/session';
import { PageMargeProduit, PageMarges } from './Marges';

export const routesAdminMarges: RouteObject[] = [
  { path: 'marges', element: <RequirePermission permission="marge.lire"><PageMarges /></RequirePermission> },
  { path: 'marges/produits/:id', element: <RequirePermission permission="marge.lire"><PageMargeProduit /></RequirePermission> },
];

export const navAdminMarges: EntreeNav[] = [
  { libelle: 'Marges et rentabilité', vers: '/admin/marges', permission: 'marge.lire', icone: TrendingUp, groupe: 'Finance' },
];
